import AddProduct from '../components/Products/AddProduct';

// Standalone route for the same form the list page shows in its Drawer.
// The form itself renders no chrome, so the page supplies it.
export default function ProductAddPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Нов производ</h2>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <AddProduct />
      </div>
    </div>
  );
}
